export enum RelAttributes {
  NO_FOLLOW = "nofollow",
  SPONSORED = "sponsored"
}
